import useOutOfStockModal from './useOutOfStockModal';

export default useOutOfStockModal;
